import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
  ViewRef,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MatOption } from "@angular/material/core";
import { MatSelect } from "@angular/material/select";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable, Subject, Subscription } from "rxjs";
import { action } from "src/app/interfaces/action";
import { CardView } from "src/app/interfaces/cardview";
import { ChildrenForm } from "src/app/interfaces/children";
import { columnsDef } from "src/app/interfaces/columnsDef";
import { DataGridColumns } from "src/app/interfaces/dagrid-columns";
import { Filter } from "src/app/interfaces/filter";
import { FormConfig } from "src/app/interfaces/formconfig";
import { HTTPService } from "src/app/services/http.service";
import { PermissionServices } from "src/app/services/permission.services";
import { SnackbarService } from "src/app/services/snackbar.service";
import { ThemeService } from "src/app/services/theme.service";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { UserConfigServices } from "src/app/services/user-config.services";
import { ObjectUtil } from "src/app/system-utils/utils/ObjectUtil";

@Component({
    selector: "simple-form",
    templateUrl: "./simple-form.component.html",
    styleUrls: ["./simple-form.component.scss"],
    standalone: false
})
export class SimpleFormComponent implements OnInit {
  @ViewChild("selectFilter") selectFilter: MatSelect;

  subFind: Subscription;
  subEdit: Subscription;
  subUser: Subscription;
  subActions: Subscription;
  subGetFromActions: Subscription;

  @Input() entityName: string;
  @Input() condition: string;
  @Input() nodata: boolean = false;
  @Input() parentRow: CardView;
  @Input() child: ChildrenForm;

  @Input() events: Observable<void>;

  loading: boolean = true;
  showLimitLinesError = false;
  evento: string;
  editingRowIndex: number = -1;
  filtrando: boolean = false;
  showGetFrom: boolean = false;
  totalLines: number;
  pageNumber: number = 0;
  changed: boolean = false;
  row: Object = {};
  editingRow: object;
  formGroup: UntypedFormGroup;
  autoRefresh = false;
  fatherCondition: string;
  dataRows: any;
  removeReference: string = "S";

  editing: Subject<Boolean> = new Subject<Boolean>();

  actionList: action[] = [];
  userConfig: object;
  formViewColumns = 3;
  formConfig: FormConfig[] = [];
  tableInformation: columnsDef[];
  $$REFERENCES: ChildrenForm[];

  filter: Filter[] = [];
  columns: DataGridColumns[] = [];
  showAction = false;
  canEdit: boolean = true;

  readonly pageLimit = 500;
  readonly alterando: string = "editando";
  readonly inserindo: string = "inserindo";
  readonly acao: string = "acao";

  constructor(
    private fb: UntypedFormBuilder,
    private uas: UserAuthenticationServices,
    private cd: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private http: HTTPService,
    private ucs: UserConfigServices,
    private ap: PermissionServices,
    private snackBar: SnackbarService,
    public ThemeService:ThemeService
  ) {}

  ngOnInit(): void {
    this.spinner.show("infoLoading");

    this.editing.next(false);

    this.subEdit = this.editing.subscribe((editing) => {
      /* if (!editing && ObjectUtil.isNotEmpty(this.componentedit)) {
        this.removeComponentEdit();
      }*/

      if (!editing && this.changed) {
        this.apply(false);
      }

      if (editing) {
        this.autoRefresh = false;
      }
    });

  }

  ngAfterViewInit(): void {

    this.getAllData();

  }

  apply(byAutoRefesh: boolean = false) {
    this.evento = null;

    if (ObjectUtil.isNotEmpty(this.parentRow)) {
      let obFather = {};
      if (ObjectUtil.isNotEmpty(this.child)) {
        this.child.columns.forEach((y) => {
          obFather[y.column] = this.parentRow.linha[y.columnRef];
        });
      }

      if (Object.keys(obFather).length > 0) {
        this.fatherCondition = ObjectUtil.transformConditionToString(obFather);
      }
    }

    if (ObjectUtil.isNotEmpty(this.fatherCondition)) {
      this.condition =
        this.fatherCondition + " AND " + this.transformcondition();
    } else {
      this.condition = this.transformcondition();
    }

    this.filtrando = true;
    if (this.condition != null) {
      if (
        this.condition.indexOf("{") > -1 &&
        this.condition.indexOf("}") > -1
      ) {
        if (byAutoRefesh) {
          this.snackBar.showError(
            "Não é permitido ativar a atualização automática com parâmetros variável."
          );
          this.autoRefresh = false;
          return;
        }
        /*this.dialogServices.openGenericDialog(
          PromptFilterViewComponent,
          { data: this.condition, lastFilter: this.lastFilter },
          (data) => {
            this.condition = JSON.parse(data).expressao;
            this.lastFilter = JSON.parse(data).group;

            this.refreshData(0, byAutoRefesh);
          },
          () => {
            this.spinner.hide(this.entityName);
          }
        );*/
      } else {
        this.refreshData(0, byAutoRefesh);
      }
    } else {
      this.refreshData(0, byAutoRefesh);
    }
  }

  transformcondition(): string {
    let condition: string = "";

    if (ObjectUtil.isNotEmpty(this.selectFilter)) {
      if ((this.selectFilter.selected as MatOption[]).length > 0) {
        let i: number = 0;
        (this.selectFilter.selected as MatOption[]).forEach((value) => {
          if (i == 0) {
            condition = condition + " " + (value.value as Filter).expression;
          } else {
            condition =
              condition + " AND " + (value.value as Filter).expression;
          }
          i++;
        });
      } else {
        condition = " 0=0 ";
      }
    } else {
      condition = " 0=0 ";
    }

    return condition;
  }

  refreshData(
    currentPage: number,
    byAutoRefesh: boolean = false,
    callbackFunction?: () => {}
  ) {
    return new Promise((resolve, reject) => {
      this.loading = true;
      this.showLimitLinesError = false;
      if (byAutoRefesh) {
        //currentPage = this.paginator.pageIndex * this.paginator.pageSize;
      }

      let ob = {
        entityName: this.entityName,
        showPresentation: true,
        showRelationshipData: false,
        showRelationship: true,
        fetchSize: currentPage,
        rows: this.pageLimit,
      };

      if (currentPage == -1) {
        ob["condition"] = "0=1";
      } else {
        if (ObjectUtil.isNotEmpty(this.condition)) {
          ob["condition"] = this.condition;
        }
      }

      if (currentPage > 9500) {
        this.showLimitLinesError = true;
        return;
      }

      let index = -1;

      if (this.evento == this.alterando || this.evento == this.acao) {
        //|| this.evento == this.inserindo ){
        //if ( this.evento == this.alterando || this.evento == ){
        index = this.editingRowIndex;
        //}
      }

      if (!byAutoRefesh) {
        this.spinner.show(this.entityName);
      }

      if (this.filtrando) {
        //this.gridApi.setRowData([]);
        this.filtrando = false;
      }

      this.subFind = this.http
        .post(ob, "JsonBrokerServices/find", true)
        .subscribe(
          (x) => {
            let tableInformation: columnsDef[] = x["table_information"];
            this.totalLines = x["totalLines"];
            let $$REFERENCES: ChildrenForm[] = x["$$REFERENCES"];
            // this.addcolumns(tableInformation);
            this.dataRows = x[this.entityName];

            if (this.dataRows == null || this.dataRows.length > 1) {
              //Verificar como vai ficar a utilização do componente no futuro, atualmente é utilizado para criar a edição de um único registro.
              this.snackBar.showError(
                "Só é possível trabalhar com uma linha no Simple-Form."
              );
              this.autoRefresh = false;
              return;
            }

            this.spinner.hide(this.entityName);

            setTimeout(() => {
              if (
                this.cd !== null &&
                this.cd !== undefined &&
                !(this.cd as ViewRef).destroyed
              ) {
                this.cd.detectChanges();
              }
            }, 250);

            if (callbackFunction != null) {
              callbackFunction.call(this);
            }

            if (
              this.userConfig["config"] != null &&
              this.userConfig["config"].length > 0
            ) {
              this.formConfig = this.userConfig["config"];
              this.formConfig.forEach((config: FormConfig) => {
                let col: columnsDef = tableInformation.find(
                  (column) => column.COLUMNNAME === config.name
                );
                if (col != null) {
                  col.cols = config.colspan == undefined ? 1 : config.colspan;
                  col.rows = config.rowspan == undefined ? 1 : config.rowspan;
                  col.x = config.x;
                  col.y = config.y;
                  col.visible =
                    config.visible == undefined ? true : config.visible;
                  col.tab = config.tab == undefined ? "Geral" : config.tab;
                }
              });
            }

            this.tableInformation = tableInformation;
            this.$$REFERENCES = $$REFERENCES;
            //this.loading = false;

            this.editRow(this.dataRows[0], 0);
            resolve(this.dataRows[0]);
          },
          (error) => {
            this.spinner.hide(this.entityName);
            throw error;
          }
        );
    });
  }

  getAllData() {
    this.loading = true;

    this.subUser = this.ucs
      .loadUserConfig(this.uas.user.iduser, this.entityName)
      .subscribe((response) => {
        this.userConfig = {};
        if (ObjectUtil.isNotEmpty(response["Mktpusercfg"])) {
          if (ObjectUtil.isNotEmpty(response["Mktpusercfg"][0])) {
            if (ObjectUtil.isNotEmpty(response["Mktpusercfg"][0]["FILTER"])) {
              this.filter = JSON.parse(response["Mktpusercfg"][0]["FILTER"]);
            }

            if (ObjectUtil.isNotEmpty(response["Mktpusercfg"][0]["CONFIG"])) {
              if (ObjectUtil.isNotEmpty(response["Mktpusercfg"][0]["CONFIG"])) {
                this.userConfig = JSON.parse(
                  response["Mktpusercfg"][0]["CONFIG"]
                );

                if (
                  Object.keys(this.userConfig).findIndex(
                    (ind) => ind == "formviewcolumns"
                  ) > -1
                ) {
                  this.formViewColumns = this.userConfig["formviewcolumns"];
                }

                if (
                  Object.keys(this.userConfig).findIndex(
                    (ind) => ind == "pagesize"
                  ) > -1
                ) {
                  //this.pagesize = this.userConfig['pagesize'];
                }

                if (
                  Object.keys(this.userConfig).findIndex(
                    (ind) => ind == "config"
                  ) > -1
                ) {
                  this.formConfig = this.userConfig["config"];
                }

                if (
                  Object.keys(this.userConfig).findIndex(
                    (ind) => ind == "configgrid"
                  ) > -1
                ) {
                  this.columns = this.userConfig["configgrid"];
                }
              }
            }
          }
        }

        this.subActions = this.ucs
          .loadActions(this.entityName)
          .subscribe((responseAction) => {
            this.actionList = responseAction["Mktpdicaction"];

            this.actionList = this.actionList.filter((data) =>
              this.ap.checkActionPermission(data.IDACTION)
            );

            if (this.actionList.length > 0) {
              this.showAction = !this.showAction;
            }
            //this.loading = false;
            this.cd.detectChanges();
          });

        this.subGetFromActions = this.ucs
          .loadGetFromAction(this.entityName, this.uas.user)
          .subscribe((responseAction) => {
            let data: Object[] = responseAction["Mktpcontractpref"];
            if (data != null && data.length > 0) {
              this.showGetFrom = true;
            } else {
              this.showGetFrom = false;
            }

            //this.loading = false;
            this.cd.detectChanges();
          });

        if (!this.nodata) {
          this.refreshData(0);
        } else {
          this.refreshData(0);
        }
      });
  }

  editRow(row: object, rowIndex: number) {
    this.changed = false;

    if (!this.canEdit) {
      this.snackBar.showError("Não é permitido editar o registro.");
      this.spinner.hide("infoLoading");
      return;
    }

    this.evento = this.alterando;
    this.editing.next(true);
    this.row = row;
    this.editingRow = row;
    this.editingRowIndex = rowIndex;

    this.formGroup = this.fb.group({});

    this.loading = false;
    this.spinner.hide("infoLoading");
  }

  savingForm(data1) {
    if (data1) {
      this.changed = true;
    }

    let ob: Object = {};
    this.tableInformation
      .filter((x) => {
        return x.ISPK === 1;
      })
      .forEach((y) => {
        if (
          this.formGroup != null &&
          this.formGroup.get(y.COLUMNNAME) != null
        ) {
          ob[y.COLUMNNAME] = this.formGroup.get(y.COLUMNNAME).value;
        }
      });
  }
}
